import { Layout } from './layout';

Layout.displayName = 'VisuallyHidden';

export { Layout as VisuallyHidden };

export type { Props as VisuallyHiddenProps } from './types';
